import api from "@/services/utils/apiInstance";
import type {
  ApiItem,
  ApiListResponse,
  ListParams,
  Option,
  PagedResult,
} from "@/types/services/manualSelection/manualSelection.type.ts";

const mapToOptions = (items: ApiItem[]): Option[] =>
  items.map((item) => ({ id: item.id, name: item.name }));

function toPagedResult(
  data: ApiListResponse<ApiItem>,
  page: number,
  pageSize: number,
): PagedResult<Option> {
  const items = mapToOptions(data.item_list);
  const loadedUntil = page * pageSize;
  return {
    total: data.count,
    items,
    page,
    pageSize,
    hasMore: loadedUntil < data.count,
  };
}

export default {
  async getBrands(params: ListParams = {}): Promise<PagedResult<Option>> {
    const page = params.page ?? 1;
    const pageSize = params.page_size ?? 20;

    const { data } = await api.get<ApiListResponse<ApiItem>>(
      "/api/nameplate/manufacturer/list",
      {
        params: {
          page, page_size:
          pageSize,
          search: params.search ?? ""
        }
      },
    );

    return toPagedResult(data, page, pageSize);
  },

  async getProducts(
    brandId: string,
    params: ListParams = {},
  ): Promise<PagedResult<Option>> {
    const page = params.page ?? 1;
    const pageSize = params.page_size ?? 20;

    const { data } = await api.get<ApiListResponse<ApiItem>>(
      "/api/nameplate/product/list",
      {
        params: {
          manufacturer_id: brandId,
          page,
          page_size: pageSize,
          search: params.search ?? "",
        },
      },
    );

    return toPagedResult(data, page, pageSize);
  },
};
